

function DevHead() {
	return null;
}

export { DevHead };